export default theme => ({
  select_formcontrol: {
    width: "100%",
  },
  select_top_margin: {
    marginTop: 18,
  },
  input_margin: {
    paddingTop: theme.spacing(3),
  },
});
